<template>
  <v-avatar :color="`${color}-lighten-5`" :size="size">
    <base-image
      v-if="user.photo"
      :src="user.photo"
      :width="size"
      :height="size"></base-image>
    <span
      v-else
      class="font-weight-bold text-uppercase"
      :class="`text-${color}-darken-1`">
      {{ user.name?.[0] + user.surname?.[0] }}
    </span>
  </v-avatar>
</template>

<script setup lang="ts">
import BaseImage from '@/components/BaseImage.vue'
import { UserLink } from '@/utils/types/user'

defineOptions({
  name: 'UserAvatar',
})

withDefaults(
  defineProps<{
    user: UserLink<'photo'>
    size?: number | string
    color?: string // only colors from vuetify material color palette
  }>(),
  {
    size: 34,
    color: 'indigo',
  }
)
</script>
